export default __webpack_public_path__ + "static/media/Constructiontropvisible.63b9a6e4.svg";